import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_CIVILBUDGETCONTROLMATERIAL,
  DELETE_CIVILBUDGETCONTROLMATERIAL,
  UPDATE_CIVILBUDGETCONTROLMATERIAL,
  ADD_NEW_CIVILBUDGETCONTROLMATERIAL,
} from "./actionType";

import {
  getCivilBudgetControlMaterialSuccess,
  getCivilBudgetControlMaterialFail,
  deleteCivilBudgetControlMaterialSuccess,
  deleteCivilBudgetControlMaterialFail,
  updateCivilBudgetControlMaterialSuccess,
  updateCivilBudgetControlMaterialFail,
  addCivilBudgetControlMaterialSuccess,
  addCivilBudgetControlMaterialFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getCivilBudgetControlMaterialApi,
  updateCivilBudgetControlMaterialApi,
  deleteCivilBudgetControlMaterialApi,
  addNewCivilBudgetControlMaterialApi,
  approveCivilBudgetControlMaterialApi
} from "../../helpers/backend_helper";

function* getCivilBudgetControlMaterial({ payload: civilBudgetControlMaterial }) {
  try {
    const response = yield call(getCivilBudgetControlMaterialApi, civilBudgetControlMaterial);
    yield put(getCivilBudgetControlMaterialSuccess(GET_CIVILBUDGETCONTROLMATERIAL, response.data));
  } catch (error) {
    yield put(getCivilBudgetControlMaterialFail(GET_CIVILBUDGETCONTROLMATERIAL, error));
  }
}

function* onUpdateCivilBudgetControlMaterial({ payload: civilBudgetControlMaterial }) {
  try {
    if (civilBudgetControlMaterial.setApprove) {
      const response = yield call(approveCivilBudgetControlMaterialApi, civilBudgetControlMaterial);
      yield put(updateCivilBudgetControlMaterialSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateCivilBudgetControlMaterialApi, civilBudgetControlMaterial);
      yield put(updateCivilBudgetControlMaterialSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateCivilBudgetControlMaterialFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteCivilBudgetControlMaterial({ payload: civilBudgetControlMaterial }) {
  try {
    const response = yield call(deleteCivilBudgetControlMaterialApi, civilBudgetControlMaterial);
    yield put(deleteCivilBudgetControlMaterialSuccess({ civilBudgetControlMaterial, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteCivilBudgetControlMaterialFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewCivilBudgetControlMaterial({ payload: civilBudgetControlMaterial }) {
  try {
    const response = yield call(addNewCivilBudgetControlMaterialApi, civilBudgetControlMaterial);
    yield put(addCivilBudgetControlMaterialSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addCivilBudgetControlMaterialFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetCivilBudgetControlMaterial() {
  yield takeEvery(GET_CIVILBUDGETCONTROLMATERIAL, getCivilBudgetControlMaterial);
}

export function* watchUpdateCivilBudgetControlMaterial() {
  yield takeEvery(UPDATE_CIVILBUDGETCONTROLMATERIAL, onUpdateCivilBudgetControlMaterial);
}

export function* watchDeleteCivilBudgetControlMaterial() {
  yield takeEvery(DELETE_CIVILBUDGETCONTROLMATERIAL, onDeleteCivilBudgetControlMaterial);
}

export function* watchAddNewCivilBudgetControlMaterial() {
  yield takeEvery(ADD_NEW_CIVILBUDGETCONTROLMATERIAL, onAddNewCivilBudgetControlMaterial);
}

function* civilBudgetControlMaterialSaga() {
  yield all([
    fork(watchGetCivilBudgetControlMaterial),
    fork(watchDeleteCivilBudgetControlMaterial),
    fork(watchUpdateCivilBudgetControlMaterial),
    fork(watchAddNewCivilBudgetControlMaterial)
  ]);
}

export default civilBudgetControlMaterialSaga;
